module.exports = __webpack_public_path__ + "static/media/referral-ad.70ce0928.svg";